const vuexModules = {
    namespaced: true,
    state: {
        delivery_date: '',
        delivery_contents: ''
    },
    mutations: {
        setDelivery_date (state, val) {
            state.delivery_date = val;
        },
        setDelivery_contents (state, val) {
            state.delivery_contents = val;
        }
    }
};

export default vuexModules;
